export const ROUTERS = {
    USER: {
        HOME: "",
        PROFILE: "/personal-information",
        CREATE: "/create-capsule",
        DASHBOARD: "/dashboard",
        MYCAPSULE:"/my-capsule",
        FRIENDS: "/friends",
    },
}